import { render, staticRenderFns } from "./_base-label.vue?vue&type=template&id=0787dd2d&scoped=true&"
import script from "./_base-label.vue?vue&type=script&lang=js&"
export * from "./_base-label.vue?vue&type=script&lang=js&"
import style0 from "./_base-label.vue?vue&type=style&index=0&id=0787dd2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0787dd2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
